export const FADE_OUT_DURATION = 300; // milliseconds
export const FADE_IN_DURATION = 300; // milliseconds
export const TOTAL_TRANSITION_TIME = FADE_OUT_DURATION + FADE_IN_DURATION; // 600ms total

export const CONTENT_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
};

export const ANIMATION_STATES = {
  FADING_IN: 'fading_in',
  FADING_OUT: 'fading_out',
  IDLE: 'idle',
};
